import APICall from "../../utils/APICalls.js";

const authServiceClient = {
  login: (returnUrl = process.env.REACT_APP_URL) => {
    const baseUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");
    window.location.href = `${baseUrl}/auth/login?returnUrl=${encodeURIComponent(
      returnUrl
    )}`;
  },
  logout: async (returnUrl = process.env.REACT_APP_URL) => {
    try {
      await APICall.get(
        `auth/logout?returnUrl=${encodeURIComponent(returnUrl)}`
      );
    } catch (error) {
      console.error("Logout API error:", error);
    }

    localStorage.clear();
    sessionStorage.clear();

    // Redirect to our login page instead of Auth0
    window.location.hash = "#/login";
  },
  signInWithEmail: async (signInData) => {
    return await APICall.post("auth/email/sign-in", signInData);
  },
  getSocialLogin: async (provider, redirectUri, state) => {
    const params = new URLSearchParams({
      provider: provider,
    });

    if (redirectUri) {
      params.append("redirectUri", redirectUri);
    }

    if (state) {
      params.append("state", state);
    }

    return await APICall.get(`auth/social/login?${params.toString()}`);
  },
  signInWithOAuth: async (oAuthData) => {
    return await APICall.post("auth/social/sign-in", oAuthData);
  },
};

export default authServiceClient;
